import React from "react";
import { Box, Grid, Card, CardContent, Typography, Stack, Button } from "@mui/material";
import { features } from "../../constants";

const FeatureBlock = ({ title, content }) => (
  <Card
    variant="outlined"
    sx={{
      mb: 2,
      borderRadius: 3,
      bgcolor: "rgba(15,23,42,0.85)",
      borderColor: "rgba(148,163,184,0.25)",
    }}
  >
    <CardContent>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: 600, color: "#fff", mb: 1 }}
      >
        {title}
      </Typography>
      <Typography variant="body2" sx={{ color: "rgba(226,232,240,0.75)" }}>
        {content}
      </Typography>
    </CardContent>
  </Card>
);

const WhyFuelPro = () => {
  return (
    <Box id="features" component="section" sx={{ py: 10 }}>
      <Grid container spacing={6}>
        {/* Left copy */}
        <Grid item xs={12} md={5}>
          <Stack spacing={3}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                color: "#fff",
                fontFamily: "Poppins, sans-serif",
              }}
            >
              Take Control.  
              <br />Connect Your ATG Today.
            </Typography>

            <Typography
              variant="body1"
              sx={{
                maxWidth: 480,
                color: "rgba(226,232,240,0.8)",
              }}
            >
              Fuel Pro modernizes how you monitor and manage your station. View
              tank levels, configure settings, review alarms, and ensure
              compliance — onsite or remotely. Your ATG finally works the way a
              modern system should.
            </Typography>

            <Button
              variant="contained"
              color="primary"
              size="large"
              sx={{ fontWeight: 600, mt: 2 }}
              href="#contact"
            >
              Get Connected Now
            </Button>
          </Stack>
        </Grid>

        {/* Feature items */}
        <Grid item xs={12} md={7}>
          {features.map((f) => (
            <FeatureBlock key={f.id} title={f.title} content={f.content} />
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default WhyFuelPro;
